var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7 5.5998C5.20294 5.5998 4.8 6.00275 4.8 6.4998V19.0998C4.8 19.5969 5.20294 19.9998 5.7 19.9998H18.3C18.7971 19.9998 19.2 19.5969 19.2 19.0998V6.4998C19.2 6.00275 18.7971 5.5998 18.3 5.5998H5.7ZM3 6.4998C3 5.00864 4.20883 3.7998 5.7 3.7998H18.3C19.7912 3.7998 21 5.00864 21 6.4998V19.0998C21 20.591 19.7912 21.7998 18.3 21.7998H5.7C4.20883 21.7998 3 20.591 3 19.0998V6.4998Z",
    fill: "#3A4555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6 2C16.097 2 16.5 2.40294 16.5 2.9V6.5C16.5 6.99706 16.097 7.4 15.6 7.4C15.1029 7.4 14.7 6.99706 14.7 6.5V2.9C14.7 2.40294 15.1029 2 15.6 2Z",
    fill: "#3A4555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 2C8.89706 2 9.3 2.40294 9.3 2.9V6.5C9.3 6.99706 8.89706 7.4 8.4 7.4C7.90294 7.4 7.5 6.99706 7.5 6.5V2.9C7.5 2.40294 7.90294 2 8.4 2Z",
    fill: "#3A4555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10.1002C3 9.60314 3.40294 9.2002 3.9 9.2002H20.1C20.5971 9.2002 21 9.60314 21 10.1002C21 10.5973 20.5971 11.0002 20.1 11.0002H3.9C3.40294 11.0002 3 10.5973 3 10.1002Z",
    fill: "#3A4555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1549e31e2ca1e9fd53950c53dbec3b67.svg";
export { ForwardRef as ReactComponent };